import Checkbox from '@shared/components/Checkbox/Checkbox';
import ErrorMessage from '@shared/components/ErrorMessage/ErrorMessage';
import cx from 'classnames';
import { FormEvent, PropsWithChildren } from 'react';
import { Controller } from 'react-hook-form';

import useCreateNewRoomDataContext from '../CreateNewRoomDataProvider/useCreateNewRoomDataContext';

interface DefaultReminderProps {
  index: number;
  id: string;
}

const DefaultReminder = ({ children, index, id }: PropsWithChildren<DefaultReminderProps>) => {
  const {
    roomForm: {
      trigger,
      watch,
      control,
      formState: { errors },
    },
  } = useCreateNewRoomDataContext();

  const remindersWatch = watch('reminders');
  const isRemindersLimitReached = remindersWatch.filter(({ enabled }) => enabled).length >= 3;
  const reminderError = errors.reminders?.[index];
  const errorMessage = reminderError?.amount?.message;

  const handleCheckboxChange =
    (onChange: (event: FormEvent<HTMLDivElement>) => void) => (event: FormEvent<HTMLDivElement>) => {
      trigger('reminders');
      onChange(event);
    };

  return (
    <div className="flex flex-col items-start gap-2">
      <div className="flex gap-4">
        <Controller
          name={`reminders.${index}.enabled`}
          control={control}
          render={({ field: { onChange, value } }) => {
            const isDisabled = !value && isRemindersLimitReached;

            return (
              <Checkbox
                id={id}
                checked={value}
                containerClassName="!space-x-0 gap-4"
                onChange={handleCheckboxChange(onChange)}
                disabled={isDisabled}
              >
                <label htmlFor={id}>
                  <span className={cx('text-black', { 'cursor-pointer': !isDisabled })}>{children}</span>
                </label>
              </Checkbox>
            );
          }}
        />
      </div>
      <ErrorMessage message={errorMessage} className="!mt-0" />
    </div>
  );
};

export default DefaultReminder;
